// External libraries
import { Component } from "react";

// Preact Signals
import { effect } from "@preact/signals-react";

// Kendo React components
import { Button } from "@progress/kendo-react-buttons";
import { Ripple } from "@progress/kendo-react-ripple";

// Internal components
import { If } from "../../Common/UI/IfComponent";
import { TooltipPopupIcon } from "../../Common/UI/TooltipPopupIcon";

// Utilities
import { handleAutomations } from "../../Automation/AutomationUtils";
import { Invisible } from "../../Utilities/EntryUtils";

// Signals
import {
  disabledSections,
  isEntryPreview,
  readOnlyEntry,
} from "../../Entry/Manage/EditEntrySignals";

export class ButtonField extends Component {
  constructor({
    field,
    handleFieldChange,
    sectionIndex,
    fieldIndex,
    eventIndex,
    galleryParentName,
    isPrintPreview,
    approvalMode,
    handleSubmit,
  }) {
    super();
    const { fieldName, properties } = field;
    this.state = {
      invisible: false,
      disabled: false,
    };
    this.fieldName = typeof eventIndex === "number" ? `${fieldName}_${eventIndex}` : fieldName;
    this.label = properties?.Label || `${fieldName}:`;
    this.fieldInformation = properties?.FieldInformation;
    this.automation = properties.Automation;
    this.isReadOnly = properties?.IsReadOnly;
    this.trackLastUpdate = properties?.TrackLastUpdate;
    this.galleryParentName = galleryParentName;
    this.sectionIndex = sectionIndex;
    this.fieldIndex = fieldIndex;
    this.eventIndex = eventIndex;
    this.handleFieldChange = handleFieldChange;
    this.handleSubmit = handleSubmit;
    this.parameterValues = properties?.ParameterValues;
    this.visibilityRules = properties?.VisibilityRules;
    this.isPrintPreview = isPrintPreview;
    this.approvalMode = approvalMode;
    this.disposeDependencyEffect = () => {};
    this.disposeDisabledSectionsEffect = () => {};
  }

  shouldComponentUpdate(_, nextState) {
    return (
      this.state.value !== nextState.value ||
      this.state.invisible !== nextState.invisible ||
      this.state.disabled !== nextState.disabled
    );
  }

  componentDidMount() {
    if (this.visibilityRules) this.handleDependencyEffect();

    this.disposeDisabledSectionsEffect = effect(() => {
      const isSectionDisabled = disabledSections.value[this.sectionName];
      if (this.state.disabled !== isSectionDisabled) {
        this.setState({ disabled: isSectionDisabled });
      }
    });
  }

  componentWillUnmount() {
    this.disposeDependencyEffect();
    this.disposeDisabledSectionsEffect();
  }

  handleDependencyEffect() {
    this.disposeDependencyEffect = effect(() => {
      const result = Invisible({
        VisibilityRules: this.visibilityRules,
        parameterValues: this.parameterValues,
        eventIndex: this.eventIndex,
        galleryName: this.galleryParentName,
      });

      this.setState({
        invisible: result.invisible && !result.disabled,
        disabled: result.invisible && result.disabled,
      });
    });
  }

  addLastUpdateDate() {
    if (this.trackLastUpdate) {
      const date = new Date();
      const offset = new Date().getTimezoneOffset() * 60000;
      const LastUpdateValue = new Date(date.getTime() - offset).toISOString().replace("Z", "");

      this.handleFieldChange({
        e: { target: { name: this.fieldName }, value: LastUpdateValue },
        sectionIndex: this.sectionIndex,
        fieldIndex: this.fieldIndex,
        eventIndex: this.eventIndex,
      });
    }
  }

  render() {
    if (this.state.invisible) return;
    return (
      <Ripple className={"field-wrapper text-area-field"}>
        <div
          ref={this.inputRef}
          className="k-d-flex k-flex-col k-justify-content-end k-h-full"
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Button
              data-testid={this.fieldName}
              id={this.fieldName}
              name={this.fieldName}
              className={"k-align-self-start"}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (!this.isPrintPreview && !isEntryPreview.value) {
                  this.addLastUpdateDate();
                  handleAutomations({
                    trigger: "Manual",
                    automation: this.automation,
                    manualEvent: e,
                    handleSubmit: this.handleSubmit,
                  });
                }
              }}
              disabled={
                this.isReadOnly ||
                this.state.disabled ||
                (readOnlyEntry.value && !this.approvalMode)
              }
            >
              {this.label}
            </Button>
            <If
              condition={
                this.fieldInformation !== undefined &&
                this.fieldInformation !== "" &&
                this.fieldInformation !== "<p></p>"
              }
            >
              <TooltipPopupIcon content={this.fieldInformation} />
            </If>
          </div>
        </div>
      </Ripple>
    );
  }
}
